<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ title }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content style="margin: 1.5em 0; max-height: 65vh; overflow: auto">
    <!-- Lo que el operador tiene que saber antes de guardar -->
    <div class="aviso aviso-info">
      <mat-icon>lock</mat-icon>
      <span>
        Lo que guardes acá queda <strong>bloqueado</strong>: el clasificador
        automático no lo pisa en la corrida de la noche.
      </span>
    </div>

    @if (esMasiva) {
      <div class="aviso aviso-warn">
        <mat-icon>warning</mat-icon>
        <span>
          Se aplica el <strong>mismo valor a {{ puntos.length }} puntos</strong>
          y reemplaza la clasificación completa: lo que dejes vacío queda sin
          valor.
          @if (yaClasificados) {
            <strong>
              {{ yaClasificados }} de los seleccionados ya tienen clasificación
              y se van a reemplazar.
            </strong>
          }
        </span>
      </div>
    }

    <form
      id="formClasificacion"
      [formGroup]="form!"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Servicio: sin esto no se pueden validar los ejes de catálogo -->
      <mat-form-field>
        <mat-label>Servicio</mat-label>
        <mat-select formControlName="commodity">
          <mat-option [value]="null">Sin definir</mat-option>
          @for (c of commodities; track c) {
            <mat-option [value]="c">{{ etiquetaCommodity(c) }}</mat-option>
          }
        </mat-select>
        <mat-hint>Define contra qué catálogo se validan los demás campos</mat-hint>
      </mat-form-field>

      @if (cargandoCatalogo) {
        <div class="cargando">
          <mat-spinner diameter="20"></mat-spinner>
          <span>Cargando catálogo…</span>
        </div>
      }

      @if (catalogoVacio) {
        <div class="aviso aviso-warn">
          <mat-icon>info</mat-icon>
          <span>
            El servicio seleccionado no tiene catálogo definido: no hay valores
            para instalación, subrol, nivel de red ni segmento.
          </span>
        </div>
      }

      @if (catalogo && !catalogoVacio) {
        <!-- Eje A — activo físico -->
        @if (catalogo.tiposInstalacion.length) {
          <mat-form-field>
            <mat-label>Tipo de instalación</mat-label>
            <mat-select formControlName="tipoInstalacion">
              <mat-option [value]="null">Sin definir</mat-option>
              @for (t of catalogo.tiposInstalacion; track t) {
                <mat-option [value]="t">{{ etiquetaCodigo(t) }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <!-- Eje B — capacidad estructural. Es un CONJUNTO: un usuario con
             paneles es consumo de noche y fuente al mediodía. -->
        <label class="text-menu campo-label">Roles en la red</label>
        <ng-select
          [items]="catalogo.rolesRedGenericos"
          placeholder="Roles en la red"
          notFoundText="No se encontraron resultados"
          formControlName="rolesRed"
          [multiple]="true"
          [appendTo]="'body'"
          [closeOnSelect]="false"
        >
          <ng-template ng-label-tmp let-item="item">
            <span>{{ etiquetaCodigo(item) }}</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <span>{{ etiquetaCodigo(item) }}</span>
          </ng-template>
        </ng-select>
        <div class="ayuda">
          Describe <strong>qué puede hacer</strong> el punto, no qué está
          haciendo ahora.
        </div>

        @if (catalogo.subroles.length) {
          <mat-form-field>
            <mat-label>Subrol</mat-label>
            <mat-select formControlName="subrol">
              <mat-option [value]="null">Sin definir</mat-option>
              @for (s of catalogo.subroles; track s) {
                <mat-option [value]="s">{{ etiquetaCodigo(s) }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <!-- Eje C — nivel de red -->
        @if (catalogo.nivelesRed.length) {
          <mat-form-field>
            <mat-label>Nivel de red</mat-label>
            <mat-select formControlName="nivelRedCodigo">
              <mat-option [value]="null">Sin definir</mat-option>
              @for (n of catalogo.nivelesRed; track n.codigo) {
                <mat-option [value]="n.codigo">{{ n.etiqueta }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <!-- Eje D — segmento de usuario (no es categoría tarifaria) -->
        @if (catalogo.segmentosUsuario.length) {
          <mat-form-field>
            <mat-label>Segmento de usuario</mat-label>
            <mat-select formControlName="segmentoUsuario">
              <mat-option [value]="null">Sin definir</mat-option>
              @for (s of catalogo.segmentosUsuario; track s) {
                <mat-option [value]="s">{{ etiquetaCodigo(s) }}</mat-option>
              }
            </mat-select>
            <mat-hint>
              Sirve para comparar lo comparable, no para facturar
            </mat-hint>
          </mat-form-field>
        }

        <!-- Reversibilidad: "no sé" no es lo mismo que "no" -->
        <mat-form-field>
          <mat-label>Bidireccional</mat-label>
          <mat-select formControlName="bidireccional">
            <mat-option [value]="null">Sin definir</mat-option>
            <mat-option [value]="true">Sí, puede entregar y recibir</mat-option>
            <mat-option [value]="false">No, una sola dirección</mat-option>
          </mat-select>
          <mat-hint>
            Si no es bidireccional, una lectura en sentido inverso es una falla
          </mat-hint>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Contraparte</mat-label>
          <input
            matInput
            type="search"
            placeholder="TGS, TGN, YPF…"
            formControlName="contraparte"
          />
          <mat-hint>Sólo si el punto recibe de un tercero o le entrega</mat-hint>
        </mat-form-field>

        <!-- NAG-100 §5: sólo gas -->
        @if (esGas) {
          <mat-form-field>
            <mat-label>Clase de trazado (NAG-100)</mat-label>
            <mat-select formControlName="claseTrazado">
              <mat-option [value]="null">Sin definir</mat-option>
              <mat-option [value]="1">1</mat-option>
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="3">3</mat-option>
              <mat-option [value]="4">4</mat-option>
            </mat-select>
          </mat-form-field>
        }
      }
    </form>

    <!-- El bulk no corta en el primer error: se muestra cuál falló -->
    @if (resultadoBulk?.fallidos?.length) {
      <div class="fallidos">
        <div class="fallidos-titulo">
          {{ resultadoBulk!.ok }} de {{ resultadoBulk!.total }} clasificados.
          Fallaron {{ resultadoBulk!.fallidos.length }}:
        </div>
        @for (f of resultadoBulk!.fallidos; track f.id) {
          <div class="fallido">
            <span class="fallido-nombre">{{ nombrePunto(f.id) }}</span>
            <span class="no-info">{{ f.motivo }}</span>
          </div>
        }
      </div>
    }
  </mat-card-content>

  <mat-divider></mat-divider>

  <mat-card-actions class="fx-row fx-gap-1em" style="margin: 0.5em">
    <button
      mat-raised-button
      class="boton-guardar fx-flex-grow"
      type="submit"
      form="formClasificacion"
      color="accent"
      [disabled]="!aportaAlgo || enviando"
      [matTooltip]="
        !aportaAlgo
          ? 'El servicio solo no cuenta como clasificación: elegí al menos instalación, rol, subrol, nivel o segmento'
          : ''
      "
    >
      GUARDAR
    </button>
    <button
      class="fx-flex-grow"
      mat-raised-button
      type="button"
      (click)="close()"
    >
      Volver
    </button>
  </mat-card-actions>
</mat-card>
